import React, { Component } from "react";
import { connect } from "react-redux";
import CONFIG from "../config";
import Timeout from "../utils/components/Timeout";

class PageHeader extends Component {
  render() {
    let title = this.props.title || ""
    if (!title) {
      title = CONFIG.SHOP_NAME +
        (this.props.configStorage.isAnkaufShop()
          ? "-Ankauf"
          : "-Bestellung"
        )
    }
    return (
      <section className="" arial-label="Header">
        <div className="no-if6-changes">
          <h1 className="ser-appheadline">{title}</h1>
        </div>
        {this.props.showTimeout
          ? <Timeout />
          : null
        }
      </section>
    );
  }
}
export default connect(store => {
  return {
    configStorage: store.configStorage
  };
})(PageHeader);
